import { useState } from 'react';

const faqs = [
  {
    q: '什么是火影同人本？',
    a: '火影同人本是以火影忍者角色和世界观为基础，由粉丝自发创作的非官方漫画、插画集或小说。同人本涵盖了角色设定再创作、平行世界剧情、角色关系探索等多种类型，是同人文化中最核心的载体形式，体现了粉丝对原作的热爱与创造力。',
  },
  {
    q: '火影同人创作是否需要获得版权授权？',
    a: '严格来说，同人创作属于二次创作范畴，涉及原作的版权。在日本，大多数版权方对同人创作采取默许态度，将其视为粉丝文化的组成部分。但在商业化使用时需要注意边界。建议同人创作者在合理范围内进行非商业性创作，避免大规模商业化运作。',
  },
  {
    q: '如何开始火影同人创作？',
    a: '入门火影同人创作需要几个步骤：首先，深入理解原作的角色设定和世界观；其次，选择你感兴趣的角色或关系进行创作构思；然后，根据你的特长选择创作形式——漫画、插画或文字同人；最后，将作品发布到LOFTER、pixiv等平台，逐步积累经验与读者。',
  },
  {
    q: 'Comic Market 上如何购买火影同人本？',
    a: '参加 Comiket 需要提前了解展会日期和场馆信息。建议提前查看参展社团的目录，确定目标摊位位置。当天携带足够现金（大多数摊位只收现金），穿着舒适的鞋子，合理规划排队时间。热门社团的同人本往往在开场后迅速售罄，因此提前抵达并优先前往心仪摊位是关键。',
  },
  {
    q: '如何鉴定同人本的品相和价值？',
    a: '同人本品相鉴定主要关注封面完整度、内页有无缺漏、装订是否牢固、有无受潮褪色等。价值评估则需综合考虑画师知名度、作品稀缺度、题材热度、出版年份等因素。建议初学者从知名画师作品入手，逐步积累鉴定经验后再涉足稀有本收藏。',
  },
  {
    q: '火影同人本在哪里可以购买？',
    a: '火影同人本的获取渠道包括：日本 Comic Market 等大型同人展、日本中古同人书店（如まんだらけ）、线上平台（如とらのあな、メロンブックス）、二手交易平台（如駿河屋、メルカリ），以及国内的同人展和线上社群。不同渠道的价格和品相差异较大，建议多方比较后入手。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-500">
            关于火影同人创作与收藏的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="font-medium text-foreground-800 pr-4 text-sm md:text-base">
                  {faq.q}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}